import React, { useState } from 'react';
import Modal from './Modal';
import './ClassCard.css';

const ClassCard = ({ classData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

    const currentEnrolled = classData['Current Enrolled'];
    const maxEnrolled = classData['Max Enrolled'];
    const enrollmentPercentage = (currentEnrolled / maxEnrolled) * 100;
  
    const getEnrollmentColor = (percentage) => {
      if (percentage <= 50) {
        return '#18bdaa'; // Green
      } else if (percentage <= 95) {
        return '#f2bf56'; // Yellow
      } else {
        return '#dd6074'; 
      }
    };

    const formatRegistrationLink = (link) => {
      if (!link.startsWith('http://') && !link.startsWith('https://')) {
        return 'http://' + link;
      }
      return link;
    };

    return (
      <div>
        <div className="class-card" onClick={openModal}>
          <div className="class-name">
            <h2>{classData['Class Title']}</h2>
            <p 
              className="enrollment-status" 
              style={{ backgroundColor: getEnrollmentColor(enrollmentPercentage) }}
            >
              Enrollment: {currentEnrolled} out of {maxEnrolled}
            </p>
          </div>
          <div className="class-info">
            <div className="class-details">
              <div className="class-pair">
                <div className="detail-title">Notes</div>
                <div className="detail-value">{classData.Notes}</div>
              </div>
              <div className="class-pair">
                <div className="detail-title">Day/Time</div>
                <div className="detail-value">{classData['Day/Time']}</div>
              </div>
              <div className="class-pair">
                <div className="detail-title">Teacher</div>
                <div className="detail-value">{classData.Teacher}</div>
              </div>
              <div className="class-pair">
                <div className="detail-title">Start Date</div>
                <div className="detail-value">{classData['Start Date']}</div>
              </div>
              <div className="class-pair">
                <div className="detail-title">End Date</div>
                <div className="detail-value">{classData['End Date']}</div>
              </div>
              <div className="class-pair">
                <div className="detail-title">Enrollment Type</div>
                <div className="detail-value">{classData['Enrollment Type']}</div>
              </div>
              <div className="class-pair">
                <div className="detail-title">Registration Link</div>
                <div className="detail-value">
                  <button className="register-button">
                  <a 
                    href={formatRegistrationLink(classData['Registration Link'])} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    {classData['Register']?.label || "Register"}
                  </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={isModalOpen} onRequestClose={closeModal} classData={classData} />
      </div>
    );
  };
  
  export default ClassCard;